module.exports = __webpack_public_path__ + "static/img/anmo.56ded42.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/anmo.png
// module id = goX8
// module chunks = 1